/**
 * @generated SignedSource<<8f8fa229722c4e6975e474cb25d0b6e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelineBreadcrumbsQuery$variables = {
  fetchPipeline: boolean;
  pipelineLocator: string;
};
export type PipelineBreadcrumbsQuery$data = {
  readonly pipeline?: {
    readonly " $fragmentSpreads": FragmentRefs<"PipelineBreadcrumbsFragment">;
  } | null | undefined;
};
export type PipelineBreadcrumbsQuery = {
  response: PipelineBreadcrumbsQuery$data;
  variables: PipelineBreadcrumbsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchPipeline"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pipelineLocator"
},
v2 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "pipelineLocator"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelineBreadcrumbsQuery",
    "selections": [
      {
        "condition": "fetchPipeline",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PipelineBreadcrumbsFragment"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PipelineBreadcrumbsQuery",
    "selections": [
      {
        "condition": "fetchPipeline",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "PipelineRest",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectRest",
                "kind": "LinkedField",
                "name": "parentProject",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Projects",
                    "kind": "LinkedField",
                    "name": "ancestorProjects",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectRest",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2da01395394dafefd84144d78a586d8e",
    "id": null,
    "metadata": {},
    "name": "PipelineBreadcrumbsQuery",
    "operationKind": "query",
    "text": "query PipelineBreadcrumbsQuery(\n  $pipelineLocator: String!\n  $fetchPipeline: Boolean!\n) {\n  pipeline(pipelineLocator: $pipelineLocator) @include(if: $fetchPipeline) {\n    ...PipelineBreadcrumbsFragment\n    _id\n  }\n}\n\nfragment PipelineBreadcrumbsFragment on PipelineRest {\n  id\n  name\n  parentProject {\n    id\n    name\n    ancestorProjects {\n      project {\n        id\n        name\n        _id\n      }\n    }\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd271e649c63d5cc6303692008039d11";

export default node;
